import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import CompanyInput from "../../Inputs/CompanyInput/CompanyInput";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../hooks/useNotifaction";
import { createCompany } from "../../../redux/companySlice/companySlice";
import { createMaintenanceType, getMaintenanceTypesById, updateMaintenanceType } from "../../../redux/MaintenanceTypeSlice/MaintenanceTypeSlice";

export default function AddMaintenanceType() {
  const location = useLocation();
  const { error, status, specificMaintenanceType } = useSelector((state) => state.maintenanceType);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [maintenanceTypeData, setMaintenanceTypeData] = useState("");
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(getMaintenanceTypesById(id));
    }
  }, [id]);
  useEffect(() => {
    if (specificMaintenanceType && id) {
      setMaintenanceTypeData(specificMaintenanceType.name);
    }
  }, [specificMaintenanceType, id]);

  async function handleForm(e) {
    e.preventDefault();
    let res;
    try {
      if (!id) {
        res = await dispatch(createMaintenanceType({ name: maintenanceTypeData })).unwrap();
        notify("تم اضافة نوع عنصر الصيانة بنجاح", "success");
      } else {
        res = await dispatch(updateMaintenanceType({ id, data: { name: maintenanceTypeData } })).unwrap();
        notify("تم تحديث نوع عنصر الصيانة بنجاح", "success");
      }
      navigate("/allMaintenanceType");
    } catch (error) {
      notify(error?.message || "حدث خطأ ", "error");
    } finally {
      setMaintenanceTypeData("");
    }
  }

  return (
    <>
      <div className="main">
        <h2 className="text-white mb-4">اضافة نوع صيانة</h2>
        <form onSubmit={handleForm}>
          <div className={"card mb-3 pt-5 pb-2 px-3 companyProfile"}>
            <section className="row mb-5">
              <h4>
                {" "}
                <span>نوع الصيانة</span>
              </h4>
              <div className="col-12 mt-3 mb-2">
                <div>
                  <label htmlFor="companyName"> نوع الصيانة</label>
                  <input type="text" value={maintenanceTypeData} onChange={(e) => setMaintenanceTypeData(e.target.value)} placeholder="اسم نوع الصيانة" id="companyName" className="form-control" />
                </div>
              </div>
            </section>{" "}
            <div>
              <button type="submit" className="btn btn-primary">
                <i className="fas fa-plus me-1"></i>
                {id ? "تعديل" : "اضافة"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
